import { render } from "./colorTab.vue?vue&type=template&id=3c79b709"
import script from "./colorTab.vue?vue&type=script&lang=js"
export * from "./colorTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__